import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import * as SettingsAPI from '../../../API/SettingsAPI'
import { immer } from 'zustand/middleware/immer'

const initialState = {
    getAllUsersListData: [],
    getAllUsersListLoading: false,
    getAllUsersListError: '',
    getAllRolesAccessData: [],
    getAllRolesAccessLoading: false,
    getAllRolesCheckboxData: [],
    getRoleByIdData: [],
    getAllSettingsData: [],
    configurationLoading: false,
    configurationData: []
}

const SettingsStore = (set, get) => ({
    ...initialState,

    getAllUserList: async (designationId, orgId, deptId) => {
        set({ getAllUsersListLoading: true, getAllUsersListError: '' })
        try {
            const response = await SettingsAPI.getAllUserList(designationId, orgId, deptId)
            if (response?.status === 200) {
                set({ getAllUsersListLoading: false, getAllUsersListData: response?.data })
                return response
            } else {
                set({ getAllUsersListLoading: false, getAllUsersListData: [] })
            }
        } catch (error) {
            set({ getAllUsersListError: error.message || 'An error occurred', getAllUsersListLoading: false })
        }
    },
    getRoleById: async (roleId) => {
        set({ getAllUsersListLoading: true, getAllUsersListError: '' })
        try {
            const response = await SettingsAPI.getRoleById(roleId)
            if (response?.status === 200) {
                set({ getAllUsersListLoading: false, getRoleByIdData: response?.data })
                return response
            } else {
                set({ getAllUsersListLoading: false, getRoleByIdData: [] })
            }
        } catch (error) {
            set({ getAllUsersListError: error.message || 'An error occurred', getAllUsersListLoading: false })
        }
    },
    roleIdClear: async () => {
        set({ getRoleByIdData: [] })
    },
    getAllRolesAccess: async (orgId) => {
        set({ getAllRolesAccessLoading: true, getAllUsersListError: '' })
        try {
            const response = await SettingsAPI.GetAllRolesAccess(orgId)
            if (response?.status === 200) {
                set({ getAllRolesAccessLoading: false, getAllRolesAccessData: response?.data })
                return response
            } else {
                set({ getAllRolesAccessLoading: false, getAllRolesAccessData: [] })
            }
        } catch (error) {
            set({ getAllUsersListError: error.message || 'An error occurred', getAllRolesAccessLoading: false })
        }
    },
    getAllRolesCheckboxs: async () => {
        set({ getAllUsersListLoading: true, getAllUsersListError: '' })
        try {
            const response = await SettingsAPI.GetAllRolesCheckboxs()
            if (response?.status === 200) {
                set({ getAllUsersListLoading: false, getAllRolesCheckboxData: response?.data })
                return response
            } else {
                set({ getAllUsersListLoading: false, getAllRolesCheckboxData: [] })
            }
        } catch (error) {
            set({ getAllUsersListError: error.message || 'An error occurred', getAllUsersListLoading: false })
        }
    },
    createRoles: async (data) => {
        set({ getAllUsersListLoading: true, getAllUsersListError: '' })
        try {
            const response = await SettingsAPI.createRoles(data)
            if (response?.status === 200) {
                set({ getAllUsersListLoading: false })
                return response
            } else {
                set({ getAllUsersListLoading: false })
            }
        } catch (error) {
            set({ getAllUsersListError: error.message || 'An error occurred', getAllUsersListLoading: false })
        }
    },
    createRolePermissions: async (data) => {
        set({ getAllUsersListLoading: true, getAllUsersListError: '' })
        try {
            const response = await SettingsAPI.createRolesPermissions(data)
            if (response?.status === 200) {
                set({ getAllUsersListLoading: false })
                return response
            } else {
                set({ getAllUsersListLoading: false })
            }
        } catch (error) {
            set({ getAllUsersListError: error.message || 'An error occurred', getAllUsersListLoading: false })
        }
    },
    getApplicationSettings: async () => {
        set({ getAllUsersListLoading: true, getAllUsersListError: '' })
        try {
            const response = await SettingsAPI.getSettingsdata()
            if (response?.status === 200) {
                set({ getAllUsersListLoading: false, getAllSettingsData: response?.data })
                return response
            } else {
                set({ getAllUsersListLoading: false, getAllSettingsData: [] })
            }
        } catch (error) {
            set({ getAllUsersListError: error.message || 'An error occurred', getAllUsersListLoading: false })
        }
    },
    getConfigurationBasedOrganization: async (orgId) => {
        set({ configurationLoading: true })
        try {
            const response = await SettingsAPI.getConfigurationBasedOrganization(orgId)
            if (response?.status === 200) {
                set({ configurationLoading: false, configurationData: response?.data })
                return response
            } else {
                set({ configurationLoading: false, configurationData: [] })
            }
        } catch (error) {
            set({ getAllUsersListError: error.message || 'An error occurred', configurationLoading: false, configurationData: [] })
        }
    },
    SetConfigurationBasedOrganization: async (orgId, loginId, data) => {
        set({ configurationLoading: true })
        try {
            const response = await SettingsAPI.SetConfigurationBasedOrganization(orgId, loginId, data)
            if (response?.status === 200) {
                set({ configurationLoading: false })
                return response
            } else {
                set({ configurationLoading: false })
            }
        } catch (error) {
            set({ getAllUsersListError: error.message || 'An error occurred', configurationLoading: false })
        }
    }

})

export const useSettingsStore = create(devtools(immer(SettingsStore)))
